export default () => {
  const userAgent = window.navigator.userAgent;
  const isIeUser = userAgent.includes('MSIE ') || userAgent.includes('Trident/');

  return !isIeUser;
};
